import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requestCount = 0;

  constructor(private spinner: NgxSpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip loader for address suggestions API
    if (
      req.url.includes('api/Guacamole/getAddress?input=') ||
      req.url.includes('api/ClaimMonitor/getClaimPreviewTimelineDetails') ||
      req.url.includes('api/WebPageCapture') ||
      req.url.includes('api/platform/results') ||
      req.url.includes('/claim-monitor/pdf')
    ) {
      return next.handle(req);
    }

    this.requestCount++;
    if (this.requestCount === 1) {
      this.spinner.show();
    }

    return next.handle(req).pipe(
      finalize(() => {
        this.requestCount--;
        if (this.requestCount === 0) {
          this.spinner.hide();
        }
      })
    );
  }
}
 